var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "18px",
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\u641C\u7D22") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u9875\\u9762-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u5207\\u56FE",
    transform: "translate(-210.000000, -1392.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u641C\\u7D22",
    transform: "translate(210.000000, 1392.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62",
    x: 0,
    y: 0,
    width: 18,
    height: 18
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8214011,16.8072605 C16.5389795,17.0915259 15.8513708,16.9773385 15.8513708,16.9773385 L12.7693426,13.8928728 C9.76880848,16.2968802 5.41264294,15.9369088 2.84742456,13.0729759 C0.282206173,10.2090431 0.402317554,5.83968032 3.12099894,3.12099894 C5.83968032,0.402317554 10.2090431,0.282206173 13.0729759,2.84742456 C15.9369088,5.41264294 16.2968802,9.76880848 13.8928728,12.7693426 L16.9748854,15.8513552 C16.9748854,15.8513552 17.1007446,16.5288545 16.8214011,16.8072605 L16.8214011,16.8072605 Z M13.9634821,8.2547065 C13.9631456,5.10501165 11.4096306,2.55190472 8.25993571,2.55207155 C5.11024085,2.55223837 2.55699344,5.10561578 2.55699344,8.25531064 C2.55699344,11.4050055 5.11023037,13.9583876 8.25992523,13.9585602 C11.4098892,13.9582237 13.9633095,11.4046705 13.9634821,8.2547065 Z",
    id: "\\u5F62\\u72B6",
    fill: "#26292C",
    fillRule: "nonzero"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg);
export default __webpack_public_path__ + "static/media/搜索.c661f69d0c37955aaa88fa7f94e2e6ef.svg";
export { ForwardRef as ReactComponent };